/* Optional feature discovery stays active for drawer and theme-editor replacements. */
(function () {
  var theme = window.SugarTheme = window.SugarTheme || {};
  if (theme.runtime) return;
  var config = document.currentScript ? document.currentScript.dataset : {};
  var sources = {
    text: config.textSrc,
    'product-gallery': config.productGallerySrc,
    subscriptions: config.subscriptionsSrc,
    'cart-media': config.cartMediaSrc,
    'auto-scroll': config.autoScrollSrc,
    'auto-scroll-consumers': config.autoScrollConsumersSrc,
    'alpine-collapse': 'https://cdn.jsdelivr.net/npm/@alpinejs/collapse@3.14.9/dist/cdn.min.js',
    'alpine-core': 'https://cdn.jsdelivr.net/npm/alpinejs@3.14.9/dist/cdn.min.js',
    iconify: 'https://cdn.jsdelivr.net/npm/iconify-icon@2.3.0/dist/iconify-icon.min.js'
  };
  var deferredSymbols = document.querySelector('script[data-sugar-symbols][data-sugar-deferred-src]');
  if (deferredSymbols) sources.symbols = deferredSymbols.dataset.sugarDeferredSrc;
  var declarations = new Map();
  var scripts = new Map();
  var readyScripts = new Set();
  var generations = new WeakMap();
  var alpinePromise;
  var automaticReady = false;
  var allowEnhancements;
  var whenEnhancementsAllowed = new Promise(function (resolve) { allowEnhancements = resolve; });
  var autoScrollSelector = '[data-auto-scroll-consumer]';
  var autoScrollDemand = new Map();
  var autoScrollGenerations = new WeakMap();
  var autoScrollObserver;
  var visibleJobs = new Set();
  var intentMounts = new WeakMap();
  var openingCart = null;
  // Capture only the original parser-owned tag, never a later inert HTML insertion.
  var parserGalleryScript = document.readyState !== 'complete'
    ? document.querySelector('script[data-product-gallery-runtime][defer][src]') : null;
  // All parser-deferred gallery tags have settled by DOMContentLoaded. A gated
  // discovery must retry a failed owner, not join events that already passed.
  document.addEventListener('DOMContentLoaded', function () { parserGalleryScript = null; }, { once: true });
  var upsellsSelector = '[x-data*="cartUpsells"]';
  var subscriptionsSelector = '[data-sugar-provider="subscriptions"], [x-data*="subscriptionsBlock"]';

  function nodes(root, selector) {
    var found = root.querySelectorAll ? Array.from(root.querySelectorAll(selector)) : [];
    if (root.matches && root.matches(selector)) found.unshift(root);
    return found;
  }

  function registerAssets(root) {
    nodes(root, '[data-sugar-runtime-asset]').forEach(function (node) {
      var key = node.dataset.sugarRuntimeAsset;
      if (!key || !node.dataset.src) return;
      if (!declarations.has(key)) declarations.set(key, node);
      if (!sources[key]) sources[key] = node.dataset.src;
      if (node.dataset.loaded === 'true' && !scripts.has(key)) {
        readyScripts.add(key); scripts.set(key, Promise.resolve());
      }
    });
  }

  function pageAssets(root, strict) {
    registerAssets(root);
    var jobs = [];
    var required = [];
    declarations.forEach(function (node, key) {
      if (node.dataset.group !== 'page') return;
      if (node.dataset.selector && !nodes(root, node.dataset.selector).length) return;
      var job = load(key);
      jobs.push(job);
      if (['money', 'constants', 'pubsub', 'cart', 'global'].indexOf(key) !== -1) required.push(job);
      if (!strict) job.catch(function (error) { report(error, root); });
    });
    // Automatic startup must not wait for an unrelated overlay, animation or
    // optional stylesheet. Explicit fragment preparation remains atomic.
    return settle(strict ? jobs : required);
  }

  var dependencies = {
    cart: ['money', 'constants', 'pubsub'],
    global: ['money', 'constants', 'pubsub', 'cart'],
    'product-form': ['global', 'cart', 'cart-drawer'],
    'cart-drawer': ['global', 'cart'],
    'product-info': ['global', 'product-form'],
    'product-model': ['global'],
    'sticky-product': ['global', 'cart', 'product-form'],
    'sticky-navigation': ['global'],
    'search-form': ['global'],
    'predictive-search': ['search-form'],
    'details-disclosure': ['global'],
    'details-modal': ['global'],
    'show-more': ['global'],
    'localization-form': ['global'],
    'cart-upsells': ['money', 'pubsub', 'cart'],
    animations: ['global']
  };

  function load(key, trail) {
    registerAssets(document);
    trail = trail || [];
    if (trail.indexOf(key) !== -1) return Promise.reject(new Error('Circular runtime dependency: ' + trail.concat(key).join(' -> ')));
    if (key === 'splide' && window.Splide) return Promise.resolve();
    if (scripts.has(key)) return scripts.get(key);
    if (!sources[key]) return Promise.reject(new Error('Missing runtime asset: ' + key));
    var declaration = declarations.get(key);
    // Non-product/editor tags already have a parser-owned request. Join it even
    // before its load event; issuing another tag would execute the controller twice.
    var nativeOwner = declaration && declaration.tagName === 'SCRIPT' && declaration.hasAttribute('src') && declaration.isConnected && declaration.dataset.loadFailed !== 'true' ? declaration : null;
    var prerequisiteKeys = declaration && !nativeOwner
      ? (declaration.dataset.depends ? declaration.dataset.depends.split(/\s+/).filter(Boolean) : (dependencies[key] || [])) : [];
    var script;
    var joined = false;
    var settled = false;
    var resolveAsset, rejectAsset;
    var promise = new Promise(function (resolve, reject) { resolveAsset = resolve; rejectAsset = reject; });
    scripts.set(key, promise);
    function cleanup() {
      if (script) { script.removeEventListener('load', loaded); script.removeEventListener('error', failed); }
      if (joined) { document.removeEventListener('DOMContentLoaded', parsed); parserGalleryScript = null; }
    }
    function loaded() {
      if (settled) return;
      settled = true; cleanup();
      script.dataset.loaded = 'true';
      readyScripts.add(key); resolveAsset();
      retryVisible(key);
    }
    function failed(error) {
      if (settled) return;
      settled = true; cleanup();
      scripts.delete(key);
      if (script) { script.dataset.loadFailed = 'true'; script.remove(); }
      rejectAsset(error instanceof Error ? error : new Error('Could not load runtime asset: ' + key));
    }
    function parsed() { if (customElements.get('product-media-gallery')) loaded(); else failed(); }
    Promise.all(prerequisiteKeys.map(function (dependency) { return load(dependency, trail.concat(key)); })).then(function () {
      joined = key === 'product-gallery' && parserGalleryScript && parserGalleryScript.src === new URL(sources[key], document.baseURI).href;
      var isStyle = declaration && declaration.tagName === 'LINK';
      script = nativeOwner || (joined ? parserGalleryScript : document.createElement(isStyle ? 'link' : 'script'));
      if (!joined && !nativeOwner) {
        if (isStyle) { script.rel = 'stylesheet'; script.href = sources[key]; }
        else { script.async = true; script.src = sources[key]; }
      }
      if (key === 'symbols' && deferredSymbols) {
        script.dataset.sugarSymbols = '';
        script.dataset.commonUrl = deferredSymbols.dataset.commonUrl;
        script.dataset.coreUrl = deferredSymbols.dataset.coreUrl;
      }
      script.dataset.runtimeLib = key;
      script.addEventListener('load', loaded, { once: true });
      script.addEventListener('error', failed, { once: true });
      if (joined) document.addEventListener('DOMContentLoaded', parsed, { once: true });
      else if (!nativeOwner) document.head.appendChild(script);
    }).catch(failed);
    return promise;
  }

  function hasAlpineMarkup(root) {
    // Attribute shorthand (@click, :class) is also used by existing theme blocks.
    return nodes(root, '*').some(function (el) {
      return Array.from(el.attributes).some(function (attr) {
        return attr.name.indexOf('x-') === 0 || attr.name.charAt(0) === '@';
      });
    });
  }

  function ensureAlpine(root) {
    if (window.Alpine) return Promise.resolve();
    if (!hasAlpineMarkup(root)) return Promise.resolve();
    if (!alpinePromise) {
      alpinePromise = load('alpine-collapse').then(function () { return load('alpine-core'); })
        .catch(function (error) { alpinePromise = null; throw error; });
    }
    return alpinePromise;
  }

  // Call before inserting HTML. x-ignore prevents Alpine's own observer from
  // evaluating an optional provider while its script is still in flight.
  function prepareFeatures(root, automatic, ready) {
    var hosts = nodes(root, subscriptionsSelector);
    var upsells = sources['cart-upsells'] ? nodes(root, upsellsSelector) : [];
    upsells.forEach(function (host) { if (!host._x_dataStack) host.setAttribute('x-ignore', ''); });
    hosts.forEach(function (host) {
      if (!host._x_dataStack) host.setAttribute('x-ignore', '');
    });
    var jobs = [];
    function request(key) {
      jobs.push(load(key).then(function () { if (ready) return ready(key); }));
    }
    if (nodes(root, 'product-media-gallery').length && !customElements.get('product-media-gallery')) jobs.push((sources.splide ? load('splide') : Promise.resolve()).then(function () { return load('product-gallery'); }));
    if (hosts.length) request('subscriptions');
    if (upsells.length) request('cart-upsells');
    if (nodes(root, '[data-text-block]').length) request('text');
    if (nodes(root, 'sugar-cart-media').length) request('cart-media');
    if (!automatic && nodes(root, autoScrollSelector).length) request('auto-scroll-consumers');
    return settle(jobs);
  }

  function settle(jobs) {
    return Promise.allSettled(jobs).then(function (results) {
      var failure = results.find(function (result) { return result.status === 'rejected'; });
      if (failure) throw failure.reason;
    });
  }

  // Public preparation waits for icons before callers expose detached markup.
  function prepareOwned(root) {
    var jobs = [prepareFeatures(root)];
    if (nodes(root, 'iconify-icon').length && !customElements.get('iconify-icon')) jobs.push(load('iconify'));
    return settle(jobs);
  }

  function mountAutoScroll(host) {
    var generation = {};
    autoScrollGenerations.set(host, generation);
    return (sources.splide ? load('splide') : Promise.resolve()).then(function () { return load('auto-scroll-consumers'); }).then(function () {
      if (host.isConnected && autoScrollGenerations.get(host) === generation && theme.autoScrollConsumers) {
        theme.autoScrollConsumers.mount(host);
      }
    });
  }

  // Gate the controller request itself, not only its later animation vendor.
  function discoverAutoScroll(root) {
    var jobs = [];
    nodes(root, autoScrollSelector).forEach(function (host) {
      if (autoScrollDemand.has(host)) return;
      if (typeof IntersectionObserver === 'undefined') {
        jobs.push(mountAutoScroll(host));
        return;
      }
      if (!autoScrollObserver) {
        autoScrollObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var host = entry.target;
            if (!entry.isIntersecting || !host.isConnected || !autoScrollDemand.has(host)) return;
            autoScrollDemand.delete(host);
            autoScrollObserver.unobserve(host);
            mountAutoScroll(host).catch(function (error) { report(error, host); });
          });
        }, { rootMargin: '200px', threshold: 0 });
      }
      autoScrollDemand.set(host, true);
      autoScrollObserver.observe(host);
    });
    return settle(jobs);
  }

  function mountOwned(root, automatic) {
    root = root || document;
    var generation = {};
    generations.set(root, generation);
    function current() { return root.isConnected && generations.get(root) === generation; }
    var alpine;
    // Guard optional hosts synchronously before core can start its first scan.
    var features = prepareFeatures(root, automatic, function (key) {
      if (!current()) return;
      if (key === 'text' && theme.textBlocks) theme.textBlocks.mount(root);
      if (key === 'auto-scroll-consumers') {
        return settle(nodes(root, autoScrollSelector).map(mountAutoScroll));
      }
      if (key === 'subscriptions' || key === 'cart-upsells') return alpine.then(function () {
        if (!current()) return;
        nodes(root, key === 'subscriptions' ? subscriptionsSelector : upsellsSelector).forEach(function (host) {
          if (!host.isConnected || host._x_dataStack || !window.Alpine || !readyScripts.has(key)) return;
          // The provider registers immediately when Alpine already exists, or
          // on alpine:init. The core load event follows that synchronous event.
          Alpine.mutateDom(function () {
            Alpine.destroyTree(host);
            host.removeAttribute('x-ignore');
            Alpine.initTree(host);
          });
        });
      });
    });
    alpine = ensureAlpine(root);
    var symbols = deferredSymbols && nodes(root, '.material-symbols-outlined, .subscription-perks__icon--global, .quiz-answer__indicator--multi-checkmark').length ? load('symbols') : Promise.resolve();
    var icons = nodes(root, 'iconify-icon').length && !customElements.get('iconify-icon') ? load('iconify') : Promise.resolve();
    var autoScroll = automatic ? discoverAutoScroll(root) : Promise.resolve();
    return settle([features, alpine, icons, symbols, autoScroll]);
  }

  function prepare(root) {
    activateTypography(root);
    return pageAssets(root, true).then(function () { return prepareOwned(root); });
  }

  function mount(root, automatic) {
    root = root || document;
    if (!automatic || automaticReady) activateTypography(root);
    return pageAssets(root, !automatic).then(function () { return mountOwned(root, automatic); });
  }

  // Legacy section owners share this demand boundary; each keeps its own mount
  // and teardown logic. A removed host cannot mount after the vendor arrives.
  function onVisible(host, callback, libraryKey) {
    if (!host || typeof callback !== 'function') return function () {};
    var job = { host: host, libraryKey: libraryKey, stopped: false, started: false, observer: null, retry: false, left: false, visible: false, run: null };
    visibleJobs.add(job);
    function dispose() {
      job.stopped = true;
      if (job.observer) job.observer.disconnect();
      visibleJobs.delete(job);
    }
    function run() {
      if (job.stopped || job.started || !host.isConnected) return;
      job.started = true; job.retry = false;
      (libraryKey ? load(libraryKey) : Promise.resolve()).then(function () {
        if (!job.stopped && host.isConnected) {
          return Promise.resolve(callback()).then(function () { if (job.observer) job.observer.disconnect(); });
        }
      }).catch(function (error) {
        job.started = false; job.retry = true; job.left = !job.visible;
        report(error, host);
      });
    }
    job.run = run;
    whenEnhancementsAllowed.then(function () {
      if (job.stopped || !host.isConnected) return;
      if (typeof IntersectionObserver === 'undefined') { job.visible = true; run(); return; }
      job.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          job.visible = entry.isIntersecting;
          if (!entry.isIntersecting) { if (job.retry) job.left = true; return; }
          if (!job.retry || job.left) { job.retry = false; run(); }
        });
      }, { rootMargin: '200px', threshold: 0 });
      job.observer.observe(host);
    });
    return dispose;
  }

  function retryVisible(libraryKey) {
    visibleJobs.forEach(function (job) {
      if (!job.retry || job.started || job.stopped || !job.host.isConnected) return;
      if (typeof libraryKey === 'string' && job.libraryKey !== libraryKey) return;
      var rect = job.host.getBoundingClientRect();
      if (rect.width && rect.height && rect.top < window.innerHeight + 200 && rect.bottom > -200) job.run();
    });
  }

  function unmount(root) {
    visibleJobs.forEach(function (job) {
      if (root === job.host || (root.contains && root.contains(job.host))) {
        job.stopped = true;
        if (job.observer) job.observer.disconnect();
        visibleJobs.delete(job);
      }
    });
    nodes(root, autoScrollSelector).forEach(function (host) {
      autoScrollDemand.delete(host);
      autoScrollGenerations.delete(host);
      if (autoScrollObserver) autoScrollObserver.unobserve(host);
    });
    generations.delete(root);
    nodes(root, '*').forEach(function (node) { generations.delete(node); });
    if (theme.textBlocks) theme.textBlocks.unmount(root);
    if (theme.autoScrollConsumers) theme.autoScrollConsumers.unmount(root);
    // Alpine ignores a removed wrapper that has no own initialization marker.
    // Dispose its optional hosts here; marked roots remain Alpine's responsibility.
    if (!root.isConnected && !root._x_marker && window.Alpine) {
      nodes(root, subscriptionsSelector).forEach(function (host) {
        if (host._x_marker) Alpine.destroyTree(host);
      });
    }
  }

  function report(error, root) {
    document.dispatchEvent(new CustomEvent('sugar:runtime-error', { detail: { error: error, root: root } }));
  }

  function discover(root) {
    if (!automaticReady) return;
    if (root.closest && (root.matches('.splide') || root.querySelector('.splide'))) {
      root = root.closest('[data-auto-scroll-consumer]') || root;
    }
    mount(root, true).catch(function (error) { report(error, root); });
  }

  theme.runtime = { load: load, prepare: prepare, mount: mount, unmount: unmount,
    whenEnhancementsAllowed: whenEnhancementsAllowed, onVisible: onVisible };

  function init() {
    discover(document);
    window.addEventListener('resize', retryVisible, { passive: true });
    window.addEventListener('scroll', retryVisible, { passive: true });
    new MutationObserver(function (mutations) {
      // Invalidate removed generations before scheduling any new ones.
      mutations.forEach(function (mutation) {
        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1) unmount(node);
        });
      });
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1 || !node.isConnected) return;
          if (node.tagName !== 'SCRIPT') discover(node);
          else if (node.hasAttribute('data-sugar-runtime-asset')) discover(node.parentNode);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { discover(event.target); });
    document.addEventListener('shopify:block:select', function (event) { discover(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  }

  function activateTypography(root) {
    nodes(document, 'style[data-sugar-deferred-fonts]').forEach(function (style) { style.media = 'all'; });
    if (root && root !== document) nodes(root, 'style[data-sugar-deferred-fonts]').forEach(function (style) { style.media = 'all'; });
  }

  function ensureIntent(root) {
    if (intentMounts.has(root)) return intentMounts.get(root);
    activateTypography();
    var pending = mount(root).finally(function () { intentMounts.delete(root); });
    intentMounts.set(root, pending);
    return pending;
  }

  function startAutomatic() {
    registerAssets(document);
    init();
    // Only the native main-product hero owns this boundary. Explicit prepare/mount
    // remains eager, including an interaction before automatic discovery starts.
    var hero = document.querySelector('product-media-gallery[data-gallery-priority^="true:"] img[fetchpriority="high"]');
    if (!hero || (window.Shopify && Shopify.designMode)) { resume(); return; }
    function resume() {
      automaticReady = true;
      allowEnhancements();
      activateTypography();
      if (sources.symbols) load('symbols').catch(function (error) { report(error, document); });
      discover(document);
    }
    var started = false;
    function release() {
      if (started) return;
      started = true;
      hero.removeEventListener('load', painted);
      hero.removeEventListener('error', release);
      resume();
    }
    function painted() {
      // Decoding and two frames give the native image a paint opportunity before
      // optional requests and initialization. A pending image does not release
      // unrelated downloads just because a timer expires.
      var decoded = hero.decode ? hero.decode().catch(function () {}) : Promise.resolve();
      decoded.then(function () {
        requestAnimationFrame(function () { requestAnimationFrame(release); });
      });
    }
    hero.addEventListener('load', painted, { once: true });
    hero.addEventListener('error', release, { once: true });
    function intent(event) {
      var target = event.target;
      var cartLink = target.closest && target.closest('.header__icon--cart');
      var searchTrigger = target.closest && target.closest('[data-search-open], .header__icon--search');
      var searchRoot = searchTrigger && searchTrigger.parentElement.querySelector('.search-dialog predictive-search, .search-dialog search-form');
      var root = cartLink ? document.querySelector('sugar-cart-drawer') : searchRoot || target.closest && target.closest('product-info, sugar-cart-drawer, predictive-search, search-form, details-modal, localization-form, sticky-product, product-form, .offers');
      if (!root) return;
      ensureIntent(root).catch(function (error) { report(error, root); });
    }
    function openEarlyCart(event) {
      var link = event.target.closest && event.target.closest('.header__icon--cart');
      var isSpace = event.type === 'keydown' && (event.code === 'Space' || event.key === ' ');
      if (!link || (event.type !== 'click' && !isSpace) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || (event.type === 'click' && event.button > 0)) return;
      var drawer = document.querySelector('sugar-cart-drawer');
      if (!drawer) return;
      if (typeof drawer.open === 'function' && !intentMounts.has(drawer) && !openingCart && (!sources['style:sugar-cart-drawer.css'] || readyScripts.has('style:sugar-cart-drawer.css'))) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (openingCart) return;
      // Cart visibility depends on its controller/styles, not optional icons,
      // upsells or Alpine. Their failed or stalled requests must not hide it.
      ensureIntent(drawer).catch(function (error) { report(error, drawer); });
      var cartEssentials = ['cart-drawer', 'style:sugar-cart-drawer.css', 'style:component-cart-items.css'].filter(function (key) { return !!sources[key]; });
      openingCart = Promise.all(cartEssentials.map(function (key) { return load(key); })).then(function () {
        if (drawer.isConnected && typeof drawer.open === 'function') drawer.open(link);
      }).catch(function (error) {
        report(error, drawer);
        // Native navigation remains the recovery action; never replay a cart write.
        window.location.assign(link.href);
      }).finally(function () { openingCart = null; });
    }
    document.addEventListener('click', openEarlyCart, true);
    document.addEventListener('keydown', openEarlyCart, true);
    document.addEventListener('pointerdown', intent, true);
    document.addEventListener('keydown', intent, true);
    whenEnhancementsAllowed.then(function () {
      document.removeEventListener('pointerdown', intent, true);
      document.removeEventListener('keydown', intent, true);
    });
    if (hero.complete) { if (hero.naturalWidth) painted(); else release(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAutomatic, { once: true });
  else startAutomatic();
})();
